export default __webpack_public_path__ + "static/media/no-notifications.025e85f9.svg";